module.exports = __webpack_public_path__ + "img/灯芯草.d7bc86a0.jpg";